import { render, staticRenderFns } from "./InviteShipperMemberForm.vue?vue&type=template&id=62f16ea5&"
import script from "./InviteShipperMemberForm.vue?vue&type=script&lang=js&"
export * from "./InviteShipperMemberForm.vue?vue&type=script&lang=js&"
import style0 from "./InviteShipperMemberForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports